module.exports = __webpack_public_path__ + "static/media/bck.a8f310f9.png";